export const ACCESS = 'ACCESS';
export const SHOW_ERROR = 'SHOW_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';
export const SET_BINTU = 'SET_BINTU';